import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setBasemapNameStore } from 'store/global/map/basemapStyleInfo'

import Grow from '@material-ui/core/Grow'

import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined'

import Light from '../../../assets/Light.png'
import Dark from '../../../assets/Dark.png'
import Street from '../../../assets/Street.png'
import Outdoors from '../../../assets/Outdoors.png'
import Satelite from '../../../assets/Satelite.png'
import GHI from '../../../assets/DNI.png'
import Wind from '../../../assets/wind.png'
import Slope from '../../../assets/slope.png'

import './selectStyles.css'

function SelectStyles(props) {
  const dispatch = useDispatch()
  const basemapName = useSelector((state) => state.basemapStyle.basemapStyleName)

  const [toggler, setToggler] = useState(false)
  const [img, setImg] = useState(Satelite)

  const [btn, setBtn] = useState([
    { key: 'GHI', img: GHI, style: props.rasters.solar, lbl: 'Solar', active: false },
    { key: 'W', img: Wind, style: props.rasters.wind, lbl: 'Wind', active: false },
    { key: 'SL', img: Slope, style: props.rasters.slope, lbl: 'Slope', active: false },
    { key: 'L', img: Light, style: 'mapbox://styles/mapbox/light-v10', lbl: 'Light', active: false },
    { key: 'D', img: Dark, style: 'mapbox://styles/mapbox/dark-v10', lbl: 'Dark', active: false },
    { key: 'ST', img: Street, style: 'mapbox://styles/mapbox/streets-v11', lbl: 'Street', active: false },
    { key: 'O', img: Outdoors, style: 'mapbox://styles/mapbox/outdoors-v11', lbl: 'Outdoors', active: false },
    {
      key: 'SAT',
      img: Satelite,
      style: 'mapbox://styles/rmstycho/cl2rrcjn5003c15lbbt5urwm2',
      lbl: 'Satelite',
      active: false,
    },
  ])

  useEffect(() => {
    if (basemapName.trim() !== '') {
      if (basemapName === 'satelite') setImg(Satelite)
      if (basemapName === 'dark') setImg(Dark)
      if (basemapName === 'light') setImg(Light)
      if (basemapName === 'streets') setImg(Street)
      if (basemapName === 'outdoors') setImg(Outdoors)
      if (basemapName === 'slope') {
        setImg(Slope)
        setBtn(
          btn.map((obj) => {
            if (obj.key === 'SL') {
              return { ...obj, ['active']: true }
            }
            return obj
          }),
        )
      }
      if (basemapName === 'wind') {
        setImg(Wind)
        setBtn(
          btn.map((obj) => {
            if (obj.key === 'W') {
              return { ...obj, ['active']: true }
            }
            return obj
          }),
        )
      }
      if (basemapName === 'solar') {
        setImg(GHI)
        setBtn(
          btn.map((obj) => {
            if (obj.key === 'GHI') {
              return { ...obj, ['active']: true }
            }
            return obj
          }),
        )
      }
    }
  }, [])

  const selectStyle = (key, lbl, img, style, active) => {
    const buttons = btn
    setToggler(false)
    buttons.map((button) => {
      button.active = false
      if (button.key === key) {
        props.setStyles(style)
        dispatch(setBasemapNameStore(lbl.toLowerCase()))
        setImg(img)
        button.active = true
        key === 'SAT' ? props.bitmapToggle(true) : props.bitmapToggle(false)
      }
    })
    setBtn(buttons)
  }

  const barColorsSolar = [
    { width: '30px', height: '15px', backgroundColor: '#00f82d' },
    { width: '30px', height: '15px', backgroundColor: '#65f219' },
    { width: '30px', height: '15px', backgroundColor: '#a1f621' },
    { width: '30px', height: '15px', backgroundColor: '#c1fc00' },
    { width: '30px', height: '15px', backgroundColor: '#d9ff00' },
    { width: '30px', height: '15px', backgroundColor: '#ffee00' },
    { width: '30px', height: '15px', backgroundColor: '#ff9a02' },
    { width: '30px', height: '15px', backgroundColor: '#ff2500' },
    { width: '30px', height: '15px', backgroundColor: '#ec1f00' },
    { width: '30px', height: '15px', backgroundColor: '#e00004' },
    { width: '30px', height: '15px', backgroundColor: '#c00003' },
    { width: '30px', height: '15px', backgroundColor: '#8f0002' },
    { width: '30px', height: '15px', backgroundColor: '#490001' },
  ]

  const barColorsSolarCol = [
    { width: '30px', height: '15px', backgroundColor: '#48c15a' },
    { width: '30px', height: '15px', backgroundColor: '#75cf1a' },
    { width: '30px', height: '15px', backgroundColor: '#97da00' },
    // {width:"30px",height:"15px",backgroundColor:"#b3e200"},
    { width: '30px', height: '15px', backgroundColor: '#ceea00' },
    { width: '30px', height: '15px', backgroundColor: '#eaf200' },
    { width: '30px', height: '15px', backgroundColor: '#f5ea00' },
    { width: '30px', height: '15px', backgroundColor: '#f5d800' },
    { width: '30px', height: '15px', backgroundColor: '#f6c600' },
    { width: '30px', height: '15px', backgroundColor: '#f6b400' },
    { width: '30px', height: '15px', backgroundColor: '#f6a200' },
    // {width:"30px",height:"15px",backgroundColor:"#f79000"},
    { width: '30px', height: '15px', backgroundColor: '#f67a00' },
    { width: '30px', height: '15px', backgroundColor: '#ee5200' },
    { width: '30px', height: '15px', backgroundColor: '#de0000' },
  ]

  const barMarkerSolar = [
    { marginLeft: '', width: '2px', height: '5px', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '28px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
  ]

  const barTagsSolar = [
    { marginLeft: '20px', tag: '1680' },
    { marginLeft: '', tag: '1900' },
    { marginLeft: '', tag: '1950' },
    { marginLeft: '', tag: '2000' },
    { marginLeft: '', tag: '2050' },
    { marginLeft: '', tag: '2100' },
    { marginLeft: '', tag: '2150' },
    { marginLeft: '', tag: '2200' },
    { marginLeft: '', tag: '2250' },
    { marginLeft: '', tag: '2300' },
    { marginLeft: '', tag: '2350' },
    { marginLeft: '', tag: '2400' },
    { marginLeft: '', tag: '2410' },
    { marginLeft: '', tag: '2410+' },
  ]

  const barTagsSolarCol = [
    { marginLeft: '20px', tag: '1095' },
    { marginLeft: '', tag: '1179' },
    { marginLeft: '', tag: '1263' },
    { marginLeft: '', tag: '1348' },
    { marginLeft: '', tag: '1432' },
    { marginLeft: '', tag: '1516' },
    { marginLeft: '', tag: '1600' },
    { marginLeft: '', tag: '1685' },
    { marginLeft: '', tag: '1769' },
    { marginLeft: '', tag: '1853' },
    { marginLeft: '', tag: '1937' },
    { marginLeft: '', tag: '2022' },
    { marginLeft: '', tag: '2106' },
    { marginLeft: '', tag: '2190+' },
  ]

  const barTagsSolarChl = [
    { marginLeft: '', tag: '547' },
    { marginLeft: '', tag: '730' },
    { marginLeft: '', tag: '912' },
    { marginLeft: '', tag: '1095' },
    { marginLeft: '', tag: '1277' },
    { marginLeft: '', tag: '1461' },
    { marginLeft: '', tag: '1642' },
    { marginLeft: '', tag: '1826' },
    { marginLeft: '', tag: '2007' },
    { marginLeft: '', tag: '2191' },
    { marginLeft: '', tag: '2372' },
    { marginLeft: '', tag: '2556' },
    { marginLeft: '', tag: '2737' },
    { marginLeft: '', tag: '2920+' },
  ]

  const barColorsWind = [
    { width: '25px', height: '15px', backgroundColor: '#dcda68' },
    { width: '25px', height: '15px', backgroundColor: '#dcda45' },
    { width: '25px', height: '15px', backgroundColor: '#dbdb23' },
    { width: '25px', height: '15px', backgroundColor: '#dbdb01' },
    { width: '25px', height: '15px', backgroundColor: '#76be27' },
    { width: '25px', height: '15px', backgroundColor: '#339851' },
    { width: '25px', height: '15px', backgroundColor: '#256780' },
    { width: '25px', height: '15px', backgroundColor: '#1737af' },
    { width: '25px', height: '15px', backgroundColor: '#1111d6' },
    { width: '25px', height: '15px', backgroundColor: '#2f18de' },
    { width: '25px', height: '15px', backgroundColor: '#4c20e5' },
    { width: '25px', height: '15px', backgroundColor: '#6928ed' },
    { width: '25px', height: '15px', backgroundColor: '#792ce4' },
    { width: '25px', height: '15px', backgroundColor: '#501d98' },
    { width: '25px', height: '15px', backgroundColor: '#280f4c' },
    { width: '25px', height: '15px', backgroundColor: '#000000' },
  ]

  const barMarkerWind = [
    { marginLeft: '', width: '2px', height: '5px', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
  ]

  const barTagsWind = [
    { marginLeft: '26px', tag: '0' },
    { marginLeft: '', tag: '0.6' },
    { marginLeft: '', tag: '1.2' },
    { marginLeft: '', tag: '1.8' },
    { marginLeft: '', tag: '2.5' },
    { marginLeft: '', tag: '3.1' },
    { marginLeft: '', tag: '3.7' },
    { marginLeft: '', tag: '4.3' },
    { marginLeft: '', tag: '5' },
    { marginLeft: '', tag: '5.6' },
    { marginLeft: '', tag: '6.2' },
    { marginLeft: '', tag: '6.8' },
    { marginLeft: '', tag: '7.5' },
    { marginLeft: '', tag: '8.1' },
    { marginLeft: '', tag: '8.7' },
    { marginLeft: '', tag: '9.3' },
    { marginLeft: '', tag: '10+' },
  ]

  //{toggler===false ? <img className='style-cover' src={img} /> : <img className='style-cover' src={img} style={{boxShadow:'0px 0.5px 4px #057eff'}} />}

  return (
    <div>
      <div
        className="style-select-gc"
        style={
          toggler ? { backgroundImage: `url(${img})`, borderColor: '#03a9f4' } : { backgroundImage: `url(${img})` }
        }
        onClick={() => (toggler ? setToggler(false) : setToggler(true))}
      >
        <div className="styles-tag" style={toggler ? { backgroundColor: '#03a9f4' } : null}>
          <LayersOutlinedIcon
            style={
              toggler
                ? { fontSize: '15px', color: 'white', alignSelf: 'center' }
                : { fontSize: '15px', alignSelf: 'center' }
            }
          />
          <label
            style={
              toggler
                ? { fontSize: '11px', fontWeight: 'bold', color: 'white' }
                : { fontSize: '11px', fontWeight: 'bold' }
            }
          >
            Layers
          </label>
        </div>
      </div>

      <Grow in={toggler}>
        <div className="style-selector">
          {/*<div className='ifr-title'><p className='ifr-title-txt'>Map Styles</p></div>*/}

          {btn.map((button) => (
            <div
              className="style-btn-container-gc"
              style={button.style === null ? { display: 'none' } : null}
              onClick={() => selectStyle(button.key, button.lbl, button.img, button.style, button.active)}
            >
              <img style={button.active ? { borderColor: '#03a9f4' } : null} src={button.img} className="style-img" />
              <label
                style={button.active ? { color: '#03a9f4' } : null}
                className={button.key === 'O' ? 'style-btn-txt style-txt-od' : 'style-btn-txt'}
              >
                {button.lbl}
              </label>
            </div>
          ))}
        </div>
      </Grow>

      <Grow in={btn[0].active}>
        <div>
          <div className="leyend">
            <label className="leyend-title">Global Horizontal Irradiation</label>

            <div className="leyend-bar">
              {props.country === 'mx'
                ? barColorsSolar.map((val) => (
                    <div style={{ width: val.width, height: val.height, backgroundColor: val.backgroundColor }}></div>
                  ))
                : props.country === 'col'
                ? barColorsSolarCol.map((val) => (
                    <div style={{ width: val.width, height: val.height, backgroundColor: val.backgroundColor }}></div>
                  ))
                : props.country === 'ch'
                ? barColorsSolarCol.map((val) => (
                    <div style={{ width: val.width, height: val.height, backgroundColor: val.backgroundColor }}></div>
                  ))
                : null}
            </div>

            <label className="leyend-bar-lbl">
              kWh/m<sup>2</sup>
            </label>

            <div style={{ display: 'flex', width: '390px', marginLeft: '28px' }}>
              {barMarkerSolar.map((val) => (
                <div
                  style={{
                    marginLeft: val.marginLeft,
                    width: val.width,
                    height: val.height,
                    backgroundColor: val.backgroundColor,
                  }}
                ></div>
              ))}
            </div>

            <div style={{ display: 'flex', width: '410px', marginLeft: '23px' }}>
              {props.country === 'mx'
                ? barTagsSolar.map((val) => (
                    <label style={{ marginLeft: val.marginLeft }} className="lbl-scale">
                      {val.tag}
                    </label>
                  ))
                : props.country === 'col'
                ? barTagsSolarCol.map((val) => (
                    <label style={{ marginLeft: val.marginLeft }} className="lbl-scale">
                      {val.tag}
                    </label>
                  ))
                : props.country === 'ch'
                ? barTagsSolarChl.map((val) => (
                    <label style={{ marginLeft: val.marginLeft, marginRight: '11px' }} className="lbl-scale">
                      {val.tag}
                    </label>
                  ))
                : null}
            </div>
          </div>
        </div>
      </Grow>

      <Grow in={btn[1].active}>
        <div>
          <div className="leyend">
            <label className="leyend-title">Mean Wind Speed 100m</label>

            <div className="leyend-bar-wind">
              {barColorsWind.map((val) => (
                <div style={{ width: val.width, height: val.height, backgroundColor: val.backgroundColor }}></div>
              ))}
            </div>

            <label className="leyend-bar-lbl-wind">m/s</label>

            <div style={{ display: 'flex', width: '400px', marginLeft: '28px' }}>
              {barMarkerWind.map((val) => (
                <div
                  style={{
                    marginLeft: val.marginLeft,
                    width: val.width,
                    height: val.height,
                    backgroundColor: val.backgroundColor,
                  }}
                ></div>
              ))}
            </div>

            <div style={{ display: 'flex' }}>
              {barTagsWind.map((val) => (
                <label className="lbl-scale-wind" style={{ marginLeft: val.marginLeft }}>
                  {val.tag}
                </label>
              ))}
            </div>
          </div>
        </div>
      </Grow>

      <Grow in={btn[2].active}>
        <div>
          <div className="leyend">
            <label className="leyend-title">Slope Degree</label>

            <div className="leyend-bar-wind slopes-gradient"></div>

            <label className="leyend-bar-lbl-wind">deg°</label>

            <div style={{ display: 'flex', width: '400px', marginLeft: '28px' }}>
              <div
                style={{
                  marginLeft: '0px',
                  width: '2px',
                  height: '5px',
                  backgroundColor: '#c1c1c1',
                }}
              ></div>
              <div
                style={{
                  margin: '0 0 0 auto',
                  width: '2px',
                  height: '5px',
                  backgroundColor: '#c1c1c1',
                }}
              ></div>
            </div>

            <div style={{ display: 'flex', width: '400px', marginLeft: '28px' }}>
              <label className="lbl-scale-wind" style={{ marginLeft: '-1.5px' }}>
                0°
              </label>
              <label className="lbl-scale-wind" style={{ margin: '0 -7px 0 auto' }}>
                40°+
              </label>
            </div>
          </div>
        </div>
      </Grow>
    </div>
  )
}

export default SelectStyles
